export default "__VITE_ASSET__7ecc9b97__"